// Quem enxerga a fila de alertas da Vick, no cliente.
//
// A régua REAL é a RLS (`public.ia_alerta_visivel`, migration
// 20260904150000): adm, ou a permissão nominal `vick:<modulo>` concedida em
// Config > Permissões Especiais. Este arquivo é o espelho no front — não é a
// trava, é o que evita mostrar aba, contador e filtro de uma fila que vai
// voltar vazia.
//
// ⚠️ Mexeu na régra aqui? Mexa na função do banco e em
// `supabase/functions/_shared/vickCatalogo/tipos.ts` (consulta agregada). São
// três lugares porque são três camadas — mas descrevem a mesma decisão.

import type { IaAlertaModulo, Profile } from '../../types';

export const MODULOS_ALERTA: IaAlertaModulo[] = ['financeiro', 'rateio', 'comercial', 'geradoras'];

/** Papéis externos ao time: não veem alerta nem com a permissão marcada por engano. */
const ROLES_FORA = [
  'consumidor', 'parceiro', 'vendedor_parceiro', 'geradoras_externo',
  'empresa_parceira_admin', 'empresa_parceira_operador',
];

export function podeVerAlertaModulo(profile: Profile | null | undefined, modulo: IaAlertaModulo): boolean {
  if (!profile || profile.status !== 'active') return false;
  if (ROLES_FORA.includes(profile.role)) return false;
  if (profile.role === 'adm') return true;
  return Array.isArray(profile.permissions) && profile.permissions.includes(`vick:${modulo}`);
}

/** Módulos cuja fila esta pessoa consegue abrir. Vazio = não mostrar alerta nenhum. */
export function modulosDeAlertaVisiveis(profile: Profile | null | undefined): IaAlertaModulo[] {
  return MODULOS_ALERTA.filter((m) => podeVerAlertaModulo(profile, m));
}

/** Atalho: esta pessoa tem acesso a alguma fila de alerta? */
export function podeVerAlertas(profile: Profile | null | undefined): boolean {
  return modulosDeAlertaVisiveis(profile).length > 0;
}
